/**
 * libraryEffect.js — story 167 (HU-05 · RN-07.1, RN-07.2, D16.7). Pure.
 * What the panel says will happen when the chosen piece is dropped. A figure that is not known is left
 * out (the variant without figure); a KNOWN zero is a figure (D16.7).
 */
export const CHOICE_KIND = {
  NONE: 'NONE',
  PROCESS: 'PROCESS',
  OPERATION: 'OPERATION',
  PROCESS_LINKED_JOB: 'PROCESS_LINKED_JOB',
  PROCESS_LOCAL_JOB: 'PROCESS_LOCAL_JOB',
  PROCESS_SELECTION: 'PROCESS_SELECTION',
  TECHNOLOGY: 'TECHNOLOGY'
}

export const NO_CHOICE = { kind: CHOICE_KIND.NONE, key: '', label: '' }
export const NO_EFFECT = { key: '', params: {} }

const linkedEffect = (code, version) => (version
  ? { key: 'Creates a node linked to {{code}} v{{version}}', params: { code, version } }
  : { key: 'Creates a node linked to {{code}}', params: { code } })

/**
 * @param {Object} choice What the user chose or started to drag (see CHOICE_KIND)
 * @param {{ offeredVersionByCode: Object<string, number>, workstationCountById: Object<string, number> }} known
 *   What has already been asked to the server on behalf of the text
 */
// `technologyLabel` (P11): how a technology choice reads in the hint; the raw name when the caller gives none.
export const effectOf = (choice, { offeredVersionByCode = {}, workstationCountById = {}, technologyLabel = (technology) => technology.name } = {}) => {
  switch (choice.kind) {
    case CHOICE_KIND.PROCESS:
      return choice.operationCountKnown
        ? { key: 'Inserts the subworkflow «{{name}}» with its {{count}} operations', params: { name: choice.name, count: choice.operationCount } }
        : { key: 'Inserts the subworkflow «{{name}}» with its operations', params: { name: choice.name } }
    case CHOICE_KIND.OPERATION:
      return linkedEffect(choice.code, choice.versionNumber)
    case CHOICE_KIND.PROCESS_LINKED_JOB:
      return linkedEffect(choice.code, offeredVersionByCode[choice.code])
    case CHOICE_KIND.PROCESS_LOCAL_JOB:
      return { key: 'Creates a local copy of «{{code}}»', params: { code: choice.code } }
    case CHOICE_KIND.PROCESS_SELECTION:
      return { key: 'Creates {{count}} nodes', params: { count: choice.count } }
    case CHOICE_KIND.TECHNOLOGY: {
      const count = workstationCountById[choice.id]
      return typeof count === 'number'
        ? { key: 'Creates an empty node restricted to the {{count}} workstations of {{technology}}', params: { count, technology: technologyLabel(choice) } }
        : { key: 'Creates an empty node restricted to the workstations of {{technology}}', params: { technology: technologyLabel(choice) } }
    }
    default:
      return NO_EFFECT
  }
}
